'use strict';

namespace Search {

    type TripService = Core.TripService;
    export class UnifiedSearchService {

        constructor(
            private $http: ng.IHttpService,
            private $location: ng.ILocationService,
            private $route: ng.route.IRouteService,
            private $q: ng.IQService,
            private searchUnitService: any,
            private occupancyService: any,
            private resourceService: Core.ResourceService,
            private sharedSearchUnitService: any,
            private destinationService: any,
            private currentDestination: any,
            private holidayDeals: any,
            private preferences: any,
            private tripService: TripService,
            private searchQueryString: SearchQueryString,
            private geo: any,
            private analytics: any,
            private fidParser: Core.IFidParser
        ) {
        }

        getSearchMessage(type: UnifiedSearchType): string {
            let msg: string = '';
            switch (type) {
                case UnifiedSearchType.Holidays:
                    msg = 'SEARCHINGFLIGHTSANDHOTELS';
                    break;
                case UnifiedSearchType.Hotels:
                    msg = 'SEARCHINGHOTELS';
                    break;
                case UnifiedSearchType.Flights:
                    msg = 'SEARCHINGFLIGHTS';
                    break;
                default:
            }
            return msg;
        }

        getAreaName(type: UnifiedSearchType): string {
            let name: string = '';
            switch (type) {
                case UnifiedSearchType.Holidays:
                    name = 'holidays';
                    break;
                case UnifiedSearchType.Hotels:
                    name = 'hotels';
                    break;
                case UnifiedSearchType.Flights:
                    name = 'flights';
                    break;
                default:
            }
            return name;
        }

        populateSearchUnitService(model: UnifiedSearchModel): void {
            var destination = model.destination;
            if (destination && destination[0] && Object.keys(destination[0]).length !== 0) {
                this.searchUnitService.setDestination(destination[0]);
                this.searchUnitService.setDestinationAirport(destination[0]);
            }
            model.airports && this.searchUnitService.setMultipleDepartureAirports(model.airports);
            model.startDate && this.searchUnitService.startDate(this.searchUnitService.flight, model.startDate);
            model.endDate && this.searchUnitService.endDate(this.searchUnitService.flight, model.endDate);
            model.occupancy && this.occupancyService.setOccupancy(model.occupancy);
            model.currency && this.searchUnitService.setCurrency(model.currency);
            model.cabin && this.searchUnitService.setCabin(model.cabin);
        }

        populateModelFromSearchUnitService(trip, model: UnifiedSearchModel): void {
            if (trip) {
                if (trip.HotelsRequest) {
                    model.destination[0] = this.searchUnitService.getDestination();
                } else if (trip.FlightsRequest) {
                    model.destination[0] = this.searchUnitService.getDestinationAirport();
                }
                if (trip.FlightsRequest) {
                    let filterCriteriaAirline = trip.FlightsRequest.FilterCriteria
                        && trip.FlightsRequest.FilterCriteria.Airline;
                    let airlines = _.union(filterCriteriaAirline, trip.FlightsRequest.PreferredCarrierCodes).join(',');

                    if (TRPCONFIG.Domain2.NoAirlinesResetOnSearchPanelFixEnabled) {
                        model.airlines = airlines ? this.searchQueryString.lookupAirlines(airlines) : model.airlines;
                    } else {
                        model.airlines = this.searchQueryString.lookupAirlines(airlines);
                    }
                }
            }
            if (trip.TripType === this.tripService.tripTypes.MultiDestHoliday) {
                // API populates multiple FlightRequests with SelectedDepartureAirport by user's IP
                const flightRequests = trip.MultiDestinationFlightRequests;
                const first = flightRequests && flightRequests[0];
                if (first) {
                    this.searchUnitService.setDepartureAirports(first.SelectedDepartureAirport);
                }
            }

            var airports = this.searchUnitService.getDepartureAirports();
            model.airports = ( model.domainId === TRPCONFIG.Domain.DomainId )
                ? _.map(airports, a => ({ Code: a }))
                    : [];
            model.startDate = this.searchUnitService.startDate();
            model.endDate = this.searchUnitService.endDate();
            model.occupancy = this.occupancyService.getOccupancy();
            model.currency = this.searchUnitService.getCurrency();
            model.cabin = this.searchUnitService.getCabin();
            if (typeof this.searchUnitService.flexibleDates === 'boolean') {
                model.flexibleDates = this.searchUnitService.flexibleDates;
            }
        }

        launchSearch(
            model: UnifiedSearchModel,
            searchType: UnifiedSearchType,
            fid: string,
            savePreferences: boolean,
            allowDealsSearch: boolean,
            isFlexibleTripType: boolean
        ): void {
            model.domainId = TRPCONFIG.Domain.DomainId;

            if (savePreferences) {
                this.saveSearchModel(model);
                this.saveSearchType(searchType);
            }

            if (allowDealsSearch && (searchType === UnifiedSearchType.Holidays && !model.destination[0])) {
                // shortcircuit into holiday deals funnel
                this.holidayDealsSearch(model);
                return;
            }

            const areaName = this.getAreaName(searchType);
            this.sharedSearchUnitService.lockScreen(this.getSearchMessage(searchType), areaName + '-searchDirective');
            this.populateSearchUnitService(model);

            let modelCopy = angular.copy(model);

            let callSearch = (options) => {
                options.areaOverride = areaName;
                options.fid = fid || this.fidParser.parse();
                options.fbt = this.$location.search().boardType;

                this.sharedSearchUnitService.search(
                    undefined,
                    this.sharedSearchUnitService.showErrors,
                    options,
                    modelCopy,
                    isFlexibleTripType
                );
            };

            let options;
            switch (searchType) {
                case UnifiedSearchType.Holidays:

                    if (modelCopy.destination && this.destinationService.destinationIsCountry(modelCopy.destination)) {
                        delete modelCopy.destination;
                    }
                    options = this.prepareFlightSearchOptions(modelCopy);
                    callSearch(options);
                    break;

                case UnifiedSearchType.Hotels:

                    if (TRPCONFIG.Domain.NoDatesYetEnabled && modelCopy.noDatesYet) {
                        if (modelCopy.destination && modelCopy.destination[0]) {
                            // navigate to destination page
                            this.$location.path(modelCopy.destination[0].PagePath);
                        } else {
                            this.sharedSearchUnitService.showErrors([this.resourceService.get('SELECTDESTINATION')]);
                        }
                    } else {
                        callSearch({defaultFilters: true});
                    }
                    break;

                case UnifiedSearchType.Flights:

                    options = this.prepareFlightSearchOptions(modelCopy);
                    callSearch(options);
                    break;

                default:
            }

        }

        holidayDealsSearch(model: UnifiedSearchModel): void {

            // convert model to deals search format
            const params = {
                airportsCodes: model.airports,
                startDate: model.startDate,
                duration: model.duration,
                occupancy: model.occupancy
            };

            // mixpanel tracking
            this.analytics.track('mixpanel', 'Search', {
                Nights: params.duration,
                DepartureAirports: params.airportsCodes,
                TypeTitle: 'Holiday Deals',
                FromDate: { Date: params.startDate },
                Rooms: params.occupancy
            });

            //if (!_validateParameters(params)) { return; }

            const serialised = this.holidayDeals.serialiseParameters(params, false);
            this.sharedSearchUnitService.lockScreen('SEARCHINGDEALS');

            for (let param in serialised) {
                this.$location.search(param, serialised[param]);
            }
            this.$location.path(`/holidaydeals`);

        }

        prepareFlightSearchOptions(model: UnifiedSearchModel): void {

            let options:any = {};

            options.onewayonly = model.onewayonly;
            options.flexibleDates = TRPCONFIG.Domain.FlexibleDatesEnabled ? model.flexibleDates : true;
            options.prefilterDirectFlights = TRPCONFIG.Domain.PrefilterDirectFlightsEnabled
                && model.prefilterDirectFlights;

            let isPrefilter = TRPCONFIG.Domain.PrefilterAirlineEnabled && !_.some(model.airlines, a => a.IsPostfilter);
            options.prefilterAirlines = isPrefilter ? _.map(model.airlines, a => a.Code) : [];
            options.postfilterAirlines = !isPrefilter ? _.map(model.airlines, a => a.Title) : [];

            return options;
        }

        prepopulateModel(model: UnifiedSearchModel,
            queryStringValues: any,
            disableResetOptions?: boolean
        ): ng.IPromise<UnifiedSearchModel> {
            let tripId = this.$route.current &&
                this.$route.current.params &&
                this.$route.current.params.tripId;

            let currentDestination = this.currentDestination.getCurrentDestination({ useSearchUnitService: false });
            let searchableDestination = this.getSearchableDestination(currentDestination);

            return this.$q.all({
                    searchableDestination,
                preferences: queryStringValues.resetForm ? null : this.preferences.get('search'),
                trip: this.tripService.restoreSearchUnit(tripId)
            }).then(({
                searchableDestination,
                preferences,
                trip
            }) => {
                    if (!model.destination || !model.destination[0]) {
                        model.destination = [];
                        if (preferences && !angular.isString(preferences)) {
                        var searchArea = this.sharedSearchUnitService.getAreaInfo();
                        if (searchArea && searchArea.mode && !queryStringValues.dealsOnly) {
                            preferences.startDate = this.searchUnitService.startDate(searchArea.mode)
                                || preferences.startDate;
                            preferences.endDate = this.searchUnitService.endDate(searchArea.mode)
                                || preferences.endDate;
                            }
                        angular.extend(model, _.omit(preferences, ['domainId'])); //ensure the domainID is preserved
                            model.noDatesYet = false;
                        model.airlines = this.searchQueryString.verifyAirlineModels(model.airlines);
                        }
                        if (trip) {
                        this.populateModelFromSearchUnitService(trip, model);
                        }
                    }

                if (!disableResetOptions && TRPCONFIG.Domain2.ClearSearchPanelOptionsEnabled) {
                        model.airlines = [];
                        model.prefilterDirectFlights = false;
                        model.flexibleDates = false;
                        model.cabin = 1;
                        model.noDatesYet = false;

                        if (!searchableDestination) {
                            model.destination = [];

                            // workaround to clear destination, because validation should fail with empty destination
                        this.searchUnitService.setDestination(null, null, null);
                            this.searchUnitService.setDestinationAirport(null);
                        }
                    }

                if (searchableDestination && _.some(searchableDestination, value => value)) {
                        model.destination[0] = searchableDestination;
                    }

                _(['airports', 'startDate', 'endDate', 'occupancy', 'cabin', 'destination', 'currency'])
                    .forEach(key => {
                        const value = queryStringValues[key];
                        if (value) {
                            model[key] = value;
                        }
                    });

                if (model.domainId !== TRPCONFIG.Domain.DomainId ) {
                        model.airports = [];
                    }

                _.forEach(['airlines', 'prefilterDirectFlights'], key => {
                        const value = queryStringValues[key];
                        if (!angular.isUndefined(value)) {
                            model[key] = value;
                        }
                    });

                    if (TRPCONFIG.Domain.EnableNearestDepartureAirports) {
                        if (!model.airports || !model.airports.length) {
                        this.geo.getNearestAirports().then(airports => {
                            if (airports && (!model.airports || !model.airports.length)) {
                                    model.airports = airports;
                                }
                            });
                        }
                    }

                const currencyOptions = this.searchUnitService.getCurrencyOptions();
                if(model.currency && currencyOptions.indexOf(model.currency) === -1) {
                        model.currency = TRPCONFIG.Domain.CurrencyCode;
                    }

                    return model;
                });
        }

        getSearchableDestination(destinationPromise) {
            return destinationPromise.then(destination => {
                if (!destination || destination.Searchable !== false || !destination.Type || !destination.Id) {
                    return destination;
                }
                let childDestinationPromise = this.$http.get('/api2/destination/v2/gettopchildrenV2', {
                        params: {
                            Count: 1,
                            CultureCode: TRPCONFIG.Domain.CultureCode,
                            DomainId: TRPCONFIG.Domain.DomainId,
                            PageStrand: destination.PageStrand,
                            Type: destination.Type,
                            Id: destination.Id,
                        },
                        ignoreErrors: true,
                    })
                    .then(response => response.data[0])
                    .then(this.destinationService.enhanceLegacyDestination)
                    .then(this.destinationService.getDetails);

                return this.getSearchableDestination(childDestinationPromise);
            });
        }

        getDefaultModel(): UnifiedSearchModel {
            let model = new UnifiedSearchModel;
            model.occupancy = [new SearchOccupancy()];
            model.cabin = TRPCONFIG.Domain.DefaultSelectedFlightCabin || 1;
            model.destination = [];
            model.airports = [];
            model.airlines = [];
            model.flexibleDates = !TRPCONFIG.Domain.isAgentMode;
            model.prefilterDirectFlights = false;
            model.onewayonly = false;
            model.duration = 0;
            model.domainId = TRPCONFIG.Domain.DomainId;
            model.currency = TRPCONFIG.Domain.CurrencyCode;
            return model;
        }

        getQueryStringValues(hiddenQueryString: string): ng.IPromise<any> {
            let params: any = {};
            _.forEach((hiddenQueryString || '').split('&'), x => {
                let parts = x.split('=');
                params[parts[0]] = parts[1];
            });
            return this.searchQueryString.getQueryStringValues(params);
        }

        saveSearchModel(model: UnifiedSearchModel) {
            this.preferences.set('search', model);
        }

        saveSearchType(searchType: UnifiedSearchType) {
            this.preferences.set('searchType', searchType);
        }

        validateOccupancy(occupancy: SearchOccupancy): boolean {
            // check child ages are set
            let childAges: number[] = [];
            _.each(occupancy, (o) => {
                childAges = _.concat(childAges, o.ChildAges);
            });
            const isValidOccupancy = _.every(childAges, ca => typeof ca !== 'undefined');
            return isValidOccupancy;
        }
    }

    angular
        .module('search')
        .service('unifiedSearchService', UnifiedSearchService);

}
